import { useAxios } from "../useAxios";

export const useProspectsRequest = () => {
  const { sendRequest } = useAxios();

  const route = "/data-partnership";

  const getProspects = (params: string) => {
    return sendRequest({
      slug: "getProspects",
      url: `${route}/get-prospects?${params}`,
      method: "GET",
      all: true,
      displayErrorToast: true,
    });
  };

  const getProspectsTrialLimit = () => {
    return sendRequest({
      slug: "getProspectsTrialLimit",
      url: `${route}/prospects/trial-limit`,
      method: "GET",
    });
  };

  const autocompleteCompanies = (params: any) => {
    return sendRequest({
      slug: "autocompleteCompanies",
      url: `${route}/autocomplete/companies`,
      method: "GET",
      params,
    });
  };

  const autocompleteJobTitles = (params: any) => {
    return sendRequest({
      slug: "autocompleteJobTitles",
      url: `${route}/autocomplete/jobTitles`,
      method: "GET",
      params,
    });
  };

  const autocompleteIndustries = (params: any) => {
    return sendRequest({
      slug: "autocompleteIndustries",
      url: `${route}/autocomplete/industries`,
      method: "GET",
      params,
    });
  };

  const autocompleteLocations = (params: any) => {
    return sendRequest({
      slug: "autocompleteLocations",
      url: `${route}/autocomplete/locations`,
      method: "GET",
      params,
    });
  };

  return {
    getProspects,
    getProspectsTrialLimit,
    autocompleteCompanies,
    autocompleteJobTitles,
    autocompleteIndustries,
    autocompleteLocations,
  };
};
